export default __webpack_public_path__ + "static/media/taxis@3x.a9f0dff2.png";